<template>
  <div class="rewards-admin">
    <loading-spinner v-if="loading" class="full-screen"/>

    <template v-else>

      <b-row v-if="Array.isArray(locationOptions) && locationOptions.length" class="mb-3">
        <b-col cols="0" md="6" lg="8" class="d-flex align-items-center">Select location to filter Reward Claims and Users</b-col>
        <b-col cols="12" md="6" lg="4">
          <b-form-select v-model="selectedLocation" :options="locationOptions"></b-form-select>
        </b-col>
      </b-row>

      <b-tabs content-class="mt-3" fill>

        <!-- Claimed Rewards -->
        <b-tab title="Claimed Rewards" active>
          <b-alert show dismissible>
            To check the delivery status of the fulfilled vouchers please go to the
            <a :href="xoxodayLink" target="_blank">Xoxoxday platform.</a>
          </b-alert>

          <b-table show-empty responsive :fields="manageClaimFields" :items="manageClaimedRewardItems">

            <template #cell(id)="{ item }">
              <b-img
                :src="(item && item.rewardData ? item.rewardData.imageURL : null) || (item && item.reward && item.reward.image ? item.reward.image.fileLocation : null)"
                v-bind="{ width: 30, height: 30 }"
                rounded="circle"
              ></b-img>
            </template>

            <template #cell(rewardData.title)="{ value, item }">
              <div class="pt-1">{{ item && item.externalID ? `${item.externalID} - ` : '' }}{{ value || (item && item.reward ? item.reward.title : null) || ' - ' }}</div>
            </template>

            <template #cell(user.fullName)="{ value }">
              <div class="pt-1">{{ value || ' - ' }}</div>
            </template>

            <template #cell(createdAt)="{ value }">
              <div class="pt-1">{{ value | formatDateRelative }}</div>
            </template>

            <template #cell(costtokens)="{ value, item }">
              <span
                :style="{ backgroundColor: statusBackgroundMap[startCase(item.status)] }"
                class="status-badge"
                v-b-tooltip.hover title="This is an estimate, the actual value can vary based on the most current exchange rate.">
                ~ {{ currency }}{{ value.cost || '-' }} ({{ value.tokenCost || '-' }})
              </span>
            </template>

            <template #cell(updatedAt)="{ value }">
              <div class="pt-1">{{ value | formatDateRelative }}</div>
            </template>

            <template #cell(status)="{ value, item }">
              <b-dropdown
                v-if="!rewardClaimIsUpdating && item.status !== 'FULFILLED' && manageClaimStatuses && Array.isArray(manageClaimStatuses[item.status])"
                size="sm" class="p-0 border-0" variant="light" toggle-class="text-decoration-none p-0 border-0" no-caret
              >
                <template #button-content>
                  <span :style="{ backgroundColor: statusBackgroundMap[value] }" class="status-badge mx-0">
                    <strong>{{ value }}</strong><span style="font-size: 12px" class="ml-2 text-muted"><font-awesome-icon icon="pencil-alt"/></span>
                  </span>
                </template>
                <b-dropdown-item  v-for="({ label, status, disabled, variant, description }) in manageClaimStatuses[item.status]"
                  style="line-height: 16px !important"
                  class="my-2"
                  :key="`${item.id}-set-${status}`" @click="() => updateClaimedReward(item.id, { status })"
                  :disabled="disabled" :variant="variant">
                    <strong style="font-size: 13px">{{ label }}</strong><br/>
                    <span style="font-size: 12px" class="text-muted" v-html="description"></span>
                </b-dropdown-item>
              </b-dropdown>
              <div v-else-if="rewardClaimIsUpdating" class="d-flex justify-content-center align-items-center">
                <b-spinner variant="primary" small/>
              </div>
              <div v-else-if="item.status === 'FULFILLED'" class="d-flex justify-content-start align-items-center">
                <span :style="{ backgroundColor: statusBackgroundMap[value] }" class="status-badge mx-0">
                  <strong>{{ value }}</strong>
                </span>
              </div>
            </template>

            <!-- template #row-details="{ item }">
              <b-card>
                <b-row>
                  <b-col cols="12" md="8">
                    <dl class="row text-muted">
                      <dt class="col-sm-3">{{ $t('users.labels.emailAddress') }}</dt>
                      <dd class="col-sm-9"><a class="text-muted" :href="`mailto:${item.user.emailAddress}`">{{ item.user.emailAddress }}</a></dd>

                      <dt class="col-sm-3">{{ $t('rewards.labels.tokenCost') }}</dt>
                      <dd class="col-sm-9">{{ item.tokenCost }} <rewards-coin/></dd>

                      <dt class="col-12">{{ (item.reward || item.rewardData || {}).customMessageLabel || $t('rewards.labels.employeeMessage') }}</dt>
                      <dd class="col-12">
                        <content-editable type="STRING" v-model="item.employeeMessage"
                          :placeholder="(item.reward || item.rewardData || {}).customMessageRequired ? '(Required)' : '(Optional)'"
                          @saved="employeeMessage => updateClaimedReward(item.id, { employeeMessage })"/>
                      </dd>
                      <dt class="col-12">{{ $t('rewards.labels.recruiterMessage') }}</dt>
                      <dd class="col-12">
                        <content-editable type="STRING" placeholder="(Optional)" v-model="item.recruiterMessage"
                          @saved="recruiterMessage => updateClaimedReward(item.id, { recruiterMessage })"/>
                      </dd>

                      <dt class="col-sm-3 text-truncate">{{ $t('rewards.labels.createdAt') }}</dt>
                      <dd class="col-sm-9">{{ item.createdAt | formatDate('YYYY-MM-DD HH:mm') }}</dd>
                      <dt class="col-sm-3 text-truncate">{{ $t('rewards.labels.updatedAt') }}</dt>
                      <dd class="col-sm-9">{{ item.updatedAt | formatDate('YYYY-MM-DD HH:mm') }}</dd>
                    </dl>
                  </b-col>
                  <b-col cols="12" md="4" class="d-flex flex-column align-items-end reward-detail-actions">
                    <div class="d-flex flex-row" v-if="!rewardClaimIsUpdating && manageClaimStatuses && Array.isArray(manageClaimStatuses[item.status])">
                      <b-button class="flex-fill" :disabled="manageClaimStatuses[item.status].find(d => d && d.default).disabled"
                        @click="() => updateClaimedReward(item.id, { status: manageClaimStatuses[item.status].find(d => d && d.default).status })"
                        :variant="manageClaimStatuses[item.status].find(d => d && d.default).variant || 'outline-primary'"
                        >{{ manageClaimStatuses[item.status].find(d => d && d.default).label }}</b-button>
                      <b-dropdown v-if="manageClaimStatuses && Array.isArray(manageClaimStatuses[item.status])"
                        toggle-class="border-left-0" right variant="outline-primary">
                          <b-dropdown-item v-for="({ label, status, disabled, variant }) in manageClaimStatuses[item.status]"
                            :key="`${item.id}-set-${status}`" @click="() => updateClaimedReward(item.id, { status })"
                            :disabled="disabled" :variant="variant">
                              {{ label }}
                          </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div v-else-if="rewardClaimIsUpdating" class="d-flex justify-content-center align-items-center">
                      <b-spinner variant="primary" :small="true" />
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </template -->
            <template #empty>
              <h4 align="center">{{ $t('rewards.errors.no-rewards-claimed-yet') }}</h4>
            </template>
          </b-table>
          <div class="d-flex flex-column justify-content-center align-items-center">
            <b-pagination
              class="mb-0 mt-3"
              v-if="(manageClaimedRewards || []).length > claimedRewardsPerPage"
              v-model="claimedRewardsCurrentPage"
              :total-rows="(manageClaimedRewards || []).length"
              :per-page="claimedRewardsPerPage"
              size="sm"
            ></b-pagination>
          </div>
        </b-tab>

        <!-- Users -->
        <b-tab title="Users">
          <b-alert show dismissible>
            You may need to refresh the page to see the updated token balance when you approve/reject a claim or add/remove tokens.
          </b-alert>
          <div class="pb-3">
            <b-input v-model="userSearchTerm" placeholder="Search name or email address..." />
          </div>
          <b-table show-empty responsive :fields="manageUserFields" :items="manageUsers">

            <template #cell(avatar)="{ item }">
              <avatar :user="item" :size="30" :fullName="item.fullName" />
            </template>

            <template #cell(id)></template>

            <template #cell(fullName)="{ value }">
              <div class="pt-1"><strong>{{ value }}</strong></div>
            </template>

            <template #cell(emailAddress)="{ value }">
              <div class="pt-1">{{ value }}</div>
            </template>

            <template #cell(rewardTokensBalance)="{ value }">
              <div class="pt-1">
                <span :style="{ backgroundColor: '#ebf2ff' }" class="status-badge mx-0">
                  <strong>{{ value }} ({{ currency }}{{ roundNum((value || 0) * conversionRate) }})</strong>
                </span>
              </div>
            </template>

            <template #cell(rewardTokensTotal)="{ value }">
              <div class="pt-1">
                <span :style="{ backgroundColor: '#ebf2ff' }" class="status-badge mx-0">
                  <strong>{{ value }} ({{ currency }}{{ roundNum((value || 0) * conversionRate) }})</strong>
                </span>
              </div>
            </template>

            <template #cell(opts)="row">
              <div class="table-action-buttons pt-1">
                <b-button class="text-muted pt-1 pb-0" size="sm" @click="row.toggleDetails" variant="link">
                  <font-awesome-icon v-if="!row.detailsShowing" icon="chevron-down"/>
                  <font-awesome-icon v-else icon="chevron-up"/>
                </b-button>
              </div>
            </template>

            <template #cell(buttons)="{ item }">
              <div class="d-flex align-items-center justify-content-center pt-1">
                <b-button class="mr-2" size="sm" pill variant="outline-success" @click="selectedUser = item" v-b-modal.add-tokens-modal>Add</b-button>
                <b-button size="sm" pill variant="outline-danger" @click="selectedUser = item" v-b-modal.remove-tokens-modal>Remove</b-button>
              </div>
            </template>

            <template #row-details="{ item }">
              <b-row>
                <b-col>
                  <claimed-rewards-card
                    :isAdminView="true"
                    :claimedRewards="item.claimedRewards"
                    class="mb-3"
                  />
                  <reward-tokens-history-card
                    :rewardTokensHistory="item.rewardTokensHistory"
                  />
                </b-col>
              </b-row>
            </template>
            <template #empty>
              <h4 align="center">No users found</h4>
            </template>
          </b-table>
          <div class="d-flex flex-column justify-content-center align-items-center">
            <b-pagination
              class="mb-0 mt-3"
              v-if="usersPagination.totalPages > 1"
              v-model="usersPagination.page"
              :total-rows="usersPagination.total"
              :per-page="usersPagination.limit"
              size="sm"
            ></b-pagination>
          </div>
        </b-tab>

        <!-- Token System -->
        <b-tab title="Token System">
          <b-alert show dismissible>
            Please note that updates of the score system will only effect future transactions. If you want tokens to be awarded
            historically on past actions please contact us on the support@reallinks.io email address.
          </b-alert>
          <b-row>
            <b-col md="5">
              <h3>Preview</h3>
              <how-to-earn-tokens-card :scores="rewardScores || []" />
            </b-col>
            <b-col md="7">
              <h3>Edit</h3>
              <update-score-system :value="rewardScores" @input="updateScores" />
            </b-col>
          </b-row>
          <!-- update-score-system :value="rewardScores" @input="updateScores"/ -->
        </b-tab>
      </b-tabs>

    </template>

    <!-- Modals -->
    <b-modal
      id="add-tokens-modal"
      :title="`Add Reward Tokens${selectedUser ? ` - ${selectedUser.fullName}` : ''}`"
      ok-title="Add Tokens"
      @ok="addTokens"
      lazy
    >
    <b-input-group prepend="Event" class="mb-2">
      <b-form-select v-if="isEXPD8" v-model="addTokensForm.eventName" :options="[
          { value: 'RAFFLE_LEADERBOARD', text: 'Leaderboard prize' },
          { value: 'CELEBRATE_SUCCESS', text: 'Celebrate success' },
          { value: 'ADDED_TOKENS', text: 'Other' },
        ]"></b-form-select>
      <b-form-select v-if="isAssurant" v-model="addTokensForm.eventName" :options="[
          { value: 'RAFFLE_LEADERBOARD', text: 'Leaderboard prize' },
          { value: 'MANUAL_APPLICATION', text: 'Application' },
          { value: 'MANUAL_INTERVIEW', text: 'Interview' },
          { value: 'MANUAL_HIRE', text: 'Hire' },
          { value: 'MANUAL_ADHOC', text: 'Ad hoc' },
          { value: 'ASSURANT_BACKFILL', text: 'Transfer from old system' },
          { value: 'ADDED_TOKENS', text: 'Other' },
        ]"></b-form-select>
      <b-form-select v-else v-model="addTokensForm.eventName" :options="[
          { value: 'RAFFLE_LEADERBOARD', text: 'Leaderboard prize' },
          { value: 'ADDED_TOKENS', text: 'Other' },
        ]"></b-form-select>
      </b-input-group>

      <b-input-group prepend="Tokens" class="mb-2">
        <b-form-input v-model="addTokensForm.value" placeholder="100" type="number"></b-form-input>
      </b-input-group>
    </b-modal>

    <b-modal
      id="remove-tokens-modal"
      :title="`Add Reward Tokens${selectedUser ? ` - ${selectedUser.fullName}` : ''}`"
      ok-title="Remove Tokens"
      @ok="removeTokens"
      lazy
    >
      <b-input-group prepend="Tokens" class="mb-2">
        <b-form-input v-model="removeTokensForm.value" placeholder="100" type="number"></b-form-input>
      </b-input-group>
    </b-modal>
  </div>
</template>

<script>
import _startCase from 'lodash/startCase';
import gql from 'graphql-tag';
import ContentEditable from '@src/components/misc/ContentEditable';
import RewardTokensHistoryCard from '@src/components/rewards/RewardTokensHistory';
import ClaimedRewardsCard from '@src/components/rewards/ClaimedRewards';
import LoadingSpinner from '@/components/misc/LoadingSpinner';
import ListRewardsQuery from '@src/graphql/queries/ListRewards.gql';
// import RewardsAdminQuery from '@src/graphql/queries/RewardsAdmin.gql';
import RewardsAdminPaginatedQuery from '@src/graphql/queries/RewardsAdminPaginated.gql';
import UpdateRewardScoresMutation from '@src/graphql/mutations/UpdateRewardScores.gql';
import distanceInWords from 'date-fns/distance_in_words';
import gridMixin from '@src/mixins/grid';
import { RewardsCoin } from '@src/components/Icons';
import Avatar from '@/components/users/Avatar';
import HowToEarnTokensCard from '@src/components/rewards/HowToEarnTokens';
import UpdateScoreSystem from '@/components/campaign-admin/update-score-system';
import { mapRoot } from '@src/mixins/root';

export default {
  mixins: [
    gridMixin,
  ],
  components: {
    AssetBlock: () => import('@/components/settings/AssetBlock'),
    ContentEditable,
    ClaimedDescription: () => import('@src/components/rewards/ClaimedDescription'),
    DatePicker: () => import('vue2-datepicker'),
    RewardsProgressBar: () => import('@/components/rewards/Progress'),
    RewardsCoin,
    LoadingSpinner,
    RewardTokensHistoryCard,
    ClaimedRewardsCard,
    HowToEarnTokensCard,
    UpdateScoreSystem,
    Avatar,
  },
  data: () => ({
    err: null,
    form: null,
    rewardScheme: null,
    rewardScores: null,
    manageClaimedRewards: null,
    users: null,
    usersCurrentPage: 1,
    usersPerPage: 20,
    userSearchTerm: '',
    claimedRewardsCurrentPage: 1,
    claimedRewardsPerPage: 20,
    loading: false,
    rewardClaimIsUpdating: false,
    selectedUser: null,
    addTokensForm: {},
    removeTokensForm: {},
    selectedLocation: null,
    scimUserAggs: null,
    // New pagination state
    usersPagination: {
      page: 1,
      limit: 20,
      total: 0,
      totalPages: 1,
    },
  }),
  watch: {
    selectedLocation() {
      this.usersCurrentPage = 1;
      this.claimedRewardsCurrentPage = 1;
      // Reset pagination when location filter changes
      this.usersPagination.page = 1;
      this.$apollo.queries.rewardsAdminPaginated.refetch();
    },
    userSearchTerm() {
      // Reset pagination when search term changes
      this.usersPagination.page = 1;
      this.$apollo.queries.rewardsAdminPaginated.refetch();
    },
    'usersPagination.page'() {
      // Refetch when page changes
      this.$apollo.queries.rewardsAdminPaginated.refetch();
    },
  },
  apollo: {
    rewards: {
      query: ListRewardsQuery,
      variables() {
        const where = { isAvailableNow: null, status: 'ACTIVE' };

        return { where, isRecruiter: this.isRecruiter };
      },
      update: ({ company: { rewards } }) => rewards || [],
      result({ loading, data }) {
        if (!loading && data && data.company) {
          const { rewardScheme, rewardScores } = data.company;
          this.rewardScheme = rewardScheme ? { ...rewardScheme } : null;
          this.rewardScores = rewardScores ? [ ...rewardScores ] : null;

          if (this.isRecruiter) {
            const { claimedRewards } = data.company;
            this.manageClaimedRewards = Array.isArray(claimedRewards) ? claimedRewards : [];

            const { scimUserAggs } = data.company;
            this.scimUserAggs = scimUserAggs || null;

            console.log('CLAIMED REWARDS: ', this.manageClaimedRewards);
          }
        }
      },
      error(err) {
        this.err = err;
      },
    },
    rewardsAdminPaginated: {
      query: RewardsAdminPaginatedQuery,
      variables() {
        const where = {};

        // Add search filter - use OR to search both name and email
        if (this.userSearchTerm && this.userSearchTerm.length > 1) {
          where.OR = [
            { name: this.userSearchTerm },
            { emailAddress: this.userSearchTerm },
          ];
        }

        // Add location filter
        if (this.selectedLocation) {
          where.scim = { location: this.selectedLocation };
        }

        return {
          page: this.usersPagination.page,
          limit: this.usersPagination.limit,
          where: Object.keys(where).length > 0 ? where : undefined,
          order: 'CREATED_DESC',
        };
      },
      update: ({ rewardsAdmin }) => rewardsAdmin || { users: [], userConnections: { page: 1, limit: 20, total: 0, totalPages: 1 } },
      result({ loading, data }) {
        if (!loading && data && data.rewardsAdmin) {
          this.users = data.rewardsAdmin.users;
          this.usersPagination = { ...data.rewardsAdmin.userConnections };
          console.log({ users: data.rewardsAdmin.users, pagination: this.usersPagination });
        }
      },
      error(err) {
        this.err = err;
      },
    },
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isRecruiter', 'isRecruiterAdmin', 'isVoltaTrucks', 'isProd', 'isEXPD8', 'isAssurant' ]),
    locationOptions() {
      const { scimUserAggs } = this;
      if (!scimUserAggs) return [];
      const options = Array.isArray((scimUserAggs || {}).locations) ? scimUserAggs.locations.map(({ name }) => ({ value: name, text: name })) : [];
      if (options.length > 0) options.unshift({ value: null, text: 'All Locations' });
      return options;
    },
    manageUsers() {
      const { users } = this;
      // Backend now handles filtering, sorting, and pagination
      // Just ensure token values are integers
      return (users || []).map(el => {
        el.rewardTokensTotal = parseInt(el.rewardTokensTotal, 10) || 0;
        el.rewardTokensBalance = parseInt(el.rewardTokensBalance, 10) || 0;
        return el;
      });
    },
    manageClaimedRewardItems() {
      const { manageClaimedRewards, claimedRewardsCurrentPage, claimedRewardsPerPage } = this;
      return (manageClaimedRewards || [])
        .map(el => {
          el.rewardTokensTotal = parseInt(el.rewardTokensTotal, 10) || 0;
          el.rewardTokensBalance = parseInt(el.rewardTokensBalance, 10) || 0;
          return el;
        })
        .sort((a, b) => b.rewardTokensTotal - a.rewardTokensTotal)
        .filter(({ user }) => {
          const { scim } = user || {};
          const { location } = scim || {};
          const isLocationMatch = this.selectedLocation ? location === this.selectedLocation : true;
          return isLocationMatch;
        })
        .slice((claimedRewardsCurrentPage - 1) * claimedRewardsPerPage, claimedRewardsCurrentPage * claimedRewardsPerPage);
    },
    quantities() {
      return Array.from(Array(50)).map((v, i) => i + 1);
    },
    statusBackgroundMap: () => ({
      Requested: '#ebf2ff',
      Verified: '#ebf2ff',
      Approved: '#edffeb',
      Fulfilled: '#edffeb',
      Rejected: '#ffebeb'
    }),
    rewardSchemeCounts() {
      const { rewardTokensHistory: history } = this;
      return Object.keys(this.rewardScheme || {}).reduce((r, key) => {
        const claims = Array.isArray(history) ? history.filter(({ eventName }) => key === eventName) : [];
        return { ...r, [key]: claims.length };
      }, []);
    },
    manageClaimFields() {
      console.log({ company: this.company });
      const { rewardCoinConversionRate } = (this.company || {}).sitePreferences || {};
      const { getCurrency } = this;
      return [
        { key: 'id', label: '', thStyle: 'width:20px;' },
        { key: 'rewardData.title', label: 'Order ID - Reward Voucher' },
        { key: 'user.fullName', label: 'User' },
        {
          key: 'qtyxcost',
          label: 'Qty x Cost',
          formatter(v, k, item) {
            const { rewardData, reward } = item || {};
            const { denomination, quantity, currencyCode } = rewardData || {};
            const currency = currencyCode ? getCurrency(currencyCode) : '';

            if (!rewardData && reward) return `1 x ${currency}–`;
            if (!denomination || !quantity) return '–';
            return `${quantity} x ${currency}${denomination}`;
          },
          thStyle: 'width: 120px;'
        },
        {
          key: 'costtokens',
          label: 'Cost (Tokens)',
          formatter(v, k, item) {
            const { rewardData, reward, tokenCost: rewardCost } = item || {};
            if (!rewardData && reward) return { tokenCost: rewardCost, cost: null };
            const { denomination, quantity, tokenCost, exchangeRate } = rewardData || {};
            if (!tokenCost || !rewardCoinConversionRate) return { tokenCost: null, cost: null };
            const price = quantity && denomination ? quantity * denomination : null;
            const cost = price && exchangeRate ? price * exchangeRate : tokenCost * rewardCoinConversionRate;
            return { tokenCost, cost: Math.round(cost * 100) / 100 };
          },
          thStyle: 'width: 180px;'
        },
        { key: 'createdAt', label: 'Claimed At' },
        { key: 'updatedAt' },
        { key: 'status', formatter: value => _startCase(`${value}`.toLowerCase()), thStyle: 'width: 140px;' },
      ];
    },
    conversionRate() {
      const { rewardCoinConversionRate } = (this.company || {}).sitePreferences || {};
      return rewardCoinConversionRate || 0;
    },
    manageUserFields() {
      return [
        { key: 'avatar', label: '', thStyle: { width: '30px' } },
        { key: 'id', label: '', thStyle: { width: '0px' } },
        { key: 'fullName', label: 'Name' },
        { key: 'emailAddress', label: 'Email Address' },
        { key: 'rewardTokensBalance', label: 'Balance', thStyle: 'width: 160px;' },
        { key: 'rewardTokensTotal', label: 'Total Earned', thStyle: 'width: 160px;' },
        { key: 'buttons', label: 'Manage Tokens', thStyle: 'width: 160px;' },
        { key: 'opts', label: '', thStyle: 'width: 20px;' },
      ];
    },
    manageClaimStatuses() {
      const description = {
        requested: 'Your employee has requested this voucher, but it has not been approved<br/>or rejected by an admin yet.',
        approved: `Once you approve a voucher we send a request to Xoxoday to deliver it to<br/>the relevant employee.
          The cost of the reward will be then deducted from<br/>your Xoxoday wallet. If that's successful the satus of
          the voucher will be<br/>changed to 'Fulfilled'. This cannot be undone`,
        rejected: `Once you reject a voucher it will appear as rejected on the employee<br/>dashboard and the token cost will be
          added back to the balance of<br/>the relevant employee.`,
      };
      return {
        REQUESTED: [
          { label: this.$t('rewards.status-changes.REQUESTED.current'), status: 'REQUESTED', description: description.requested, disabled: true },
          // { label: this.$t('rewards.status-changes.VERIFIED.forward'), status: 'VERIFIED', default: true, variant: 'success' },
          { label: this.$t('rewards.status-changes.APPROVED.forward'), status: 'APPROVED', description: description.approved },
          // { label: this.$t('rewards.status-changes.FULFILLED.forward'), status: 'FULFILLED' },
          { label: this.$t('rewards.status-changes.REJECTED.forward'), status: 'REJECTED', description: description.rejected, variant: 'danger' },
        ],
        VERIFIED: [
          { label: this.$t('rewards.status-changes.REQUESTED.back'), status: 'REQUESTED', description: description.requested },
          // { label: this.$t('rewards.status-changes.VERIFIED.back'), status: 'VERIFIED' },
          { label: this.$t('rewards.status-changes.APPROVED.forward'), status: 'APPROVED', description: description.approved },
          // { label: this.$t('rewards.status-changes.FULFILLED.forward'), status: 'FULFILLED', default: true, variant: 'success' },
          { label: this.$t('rewards.status-changes.REJECTED.forward'), status: 'REJECTED', description: description.rejected, variant: 'danger' },
        ],
        APPROVED: [
          { label: this.$t('rewards.status-changes.REQUESTED.back'), status: 'REQUESTED', description: description.requested },
          // { label: this.$t('rewards.status-changes.VERIFIED.back'), status: 'VERIFIED' },
          { label: this.$t('rewards.status-changes.APPROVED.current'), status: 'APPROVED', description: description.approved, disabled: true },
          // { label: this.$t('rewards.status-changes.FULFILLED.forward'), status: 'FULFILLED', default: true, variant: 'success' },
          { label: this.$t('rewards.status-changes.REJECTED.forward'), status: 'REJECTED', description: description.rejected, variant: 'danger' },
        ],
        FULFILLED: [
          { label: this.$t('rewards.status-changes.REQUESTED.back'), status: 'REQUESTED', description: description.requested, disabled: true },
          // { label: this.$t('rewards.status-changes.VERIFIED.back'), status: 'VERIFIED' },
          { label: this.$t('rewards.status-changes.APPROVED.back'), status: 'APPROVED', description: description.approved, disabled: true },
          // { label: this.$t('rewards.status-changes.FULFILLED.current'), status: 'FULFILLED', default: true, disabled: true, variant: 'outline-primary' },
          { label: this.$t('rewards.status-changes.REJECTED.forward'), status: 'REJECTED', description: description.rejected, variant: 'danger', disabled: true },
        ],
        REJECTED: [
          { label: this.$t('rewards.status-changes.REQUESTED.back'), status: 'REQUESTED', description: description.requested, variant: 'success' },
          // { label: this.$t('rewards.status-changes.VERIFIED.back'), status: 'VERIFIED' },
          { label: this.$t('rewards.status-changes.APPROVED.back'), status: 'APPROVED', description: description.approved },
          // { label: this.$t('rewards.status-changes.FULFILLED.forward'), status: 'FULFILLED', variant: 'warning' },
          { label: 'Rejected', status: 'REJECTED', default: true, disabled: true, description: description.rejected, variant: 'outline-danger' },
        ],
      };
    },
    xoxodayLink() {
      const { isProd } = this;
      return `https://${isProd ? '' : 'staging'}stores.xoxoday.com/admin/reports/xoxo-token-report/`;
    },
    currency() {
      const { rewardDefaultCurrency } = (this.company || {}).sitePreferences || {};
      switch (rewardDefaultCurrency) {
        case 'USD':
          return '$';
        case 'EUR':
          return '€';
        case 'GBP':
          return '£';
        default:
          return rewardDefaultCurrency;
      }
    }
  },
  methods: {
    async updateClaimedReward(rewardID, update) {

      console.log({ update });

      this.rewardClaimIsUpdating = true;
      try {
        this.$assert(this.isRecruiter, 'Only recruiters can perform this action');
        await this.$apollo.mutate({
          mutation: gql`
            mutation UpdateClaimedReward($update: UpdateClaimedRewardInput!, $rewardID: ID!) {
              updateClaimedReward(update: $update, where: { id: $rewardID }) {
                id
                status
              }
            }
          `,
          variables: {
            update,
            rewardID,
          },
        });

        this.$notification({
          message: 'Claimed reward updated',
          variant: 'success',
        });

        if (update && update.status === 'REJECTED') {
          this.$apollo.queries.rewardsAdminPaginated.refetch();
        }

      } catch (err) {
        this.$notifyErr(err);
      }
      this.rewardClaimIsUpdating = false;
    },
    startCase(value) {
      return _startCase(`${value}`.toLowerCase());
    },
    async updateScores(value) {
      try {
        const update = { rewardScores: value };
        this.$log.debug({ update });

        await this.$apollo.mutate({
          mutation: UpdateRewardScoresMutation,
          variables: { update },
        });

        this.$notification({ message: 'The reward score system have been saved successfully', variant: 'success' });
      } catch (error) {
        this.$notifyErr(error, { prepend: 'Failed to save reward score system.' });
        console.log(error);
      }
      this.rewardScores = [ ...(Array.isArray(value) ? value : []) ];
    },
    async addTokens() {
      const { addTokensForm } = this;
      const { eventName, value } = addTokensForm || {};
      const { selectedUser } = this;
      const { id: userID, fullName } = selectedUser || {};
      if (!(eventName && value && userID)) {
        this.$notifyErr(null, { prepend: 'Please fill in all the required fields.' });
        return;
      }
      try {
        await this.$root.captureLog({
          eventName,
          user: { id: userID },
          dataHash: {
            value: typeof value === 'string' ? parseInt(value, 10) : value,
            adminUserID: this.user.id,
          },
        });
        this.$notification({
          message: `${value} tokens have  been added successfully to ${fullName}'s balance.`,
          variant: 'success',
        });
        this.$apollo.queries.rewardsAdminPaginated.refetch();
      } catch (err) {
        this.$log.error(err);
      }
      console.log({ eventName, value, userID });
      this.selectedUser = null;
      this.addTokensForm = {};
    },
    async removeTokens() {
      const { removeTokensForm } = this;
      const { value } = removeTokensForm || {};
      const { selectedUser } = this;
      const { id: userID, fullName } = selectedUser || {};
      if (!(value && userID)) {
        this.$notifyErr(null, { prepend: 'Please fill in all the required fields.' });
        return;
      }
      try {
        await this.$root.captureLog({
          eventName: 'REMOVED_TOKENS',
          user: { id: userID },
          dataHash: {
            value: -1 * (typeof value === 'string' ? parseInt(value, 10) : value),
            adminUserID: this.user.id,
          },
        });
        this.$notification({
          message: `${value} tokens have been removed successfully from ${fullName}'s balance.`,
          variant: 'success',
        });
        this.$apollo.queries.rewardsAdminPaginated.refetch();
      } catch (err) {
        this.$log.error(err);
      }
      console.log({ value, userID });
      this.selectedUser = null;
      this.removeTokensForm = {};
    },
    roundNum(val) {
      return Math.round(val * 100) / 100;
    },
    getCurrency(currency) {
      switch (currency) {
        case 'USD':
          return '$';
        case 'EUR':
          return '€';
        case 'GBP':
          return '£';
        default:
          return currency;
      }
    }
  },
  filters: {
    timeAgo(createdAt) {
      return distanceInWords(new Date(), createdAt, { addSuffix: true });
    },
  },
};
</script>

<style lang="scss">
.rewards-admin {
  .status-badge {
    display: inline-block;
    padding: 5px 12px;
    font-size: 13px;
    border-radius: 3px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rewards/RewardsAdmin.vue